import { render } from "./PersonalPhotos.vue?vue&type=template&id=3a1387b3&scoped=true"
import script from "./PersonalPhotos.vue?vue&type=script&lang=js"
export * from "./PersonalPhotos.vue?vue&type=script&lang=js"

import "./PersonalPhotos.vue?vue&type=style&index=0&id=3a1387b3&scoped=true&lang=css"

import exportComponent from "/home/runcloud1user/webapps/ismail-khayat-vue/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.5.26_vue@3.5.26_webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a1387b3"]])

export default __exports__